/**
 * Invitation API Utility
 *
 * API functions for delegation invitation endpoints.
 * - getInvitationByToken: Public endpoint (no auth required) to view invitation details
 * - acceptInvitation: Authenticated endpoint to accept an invitation
 */

import { preAuthGet } from './preAuthApi';
import api from './api';

export interface InvitationPublicDetails {
  invitationToken: string;
  inviteeEmail: string;
  delegatorName: string;
  collectionName: string;
  permissions: string;
  status: string;
  expiresAt: string;
  message?: string;
}

export interface InvitationAcceptResult {
  success: boolean;
  delegationId?: string;
}

/**
 * Fetch invitation details by token (no authentication required).
 * Returns masked email and public invitation metadata.
 */
export async function getInvitationByToken(token: string): Promise<InvitationPublicDetails> {
  const data = await preAuthGet(`/api/delegation-invitations/${token}`);
  return data as unknown as InvitationPublicDetails;
}

/**
 * Accept a delegation invitation (requires authentication).
 * The backend validates the authenticated user's email matches the invitation.
 */
export async function acceptInvitation(token: string): Promise<InvitationAcceptResult> {
  const response = await api.post(`/api/delegation-invitations/${token}/accept`);
  return response.data as InvitationAcceptResult;
}
